import React from "react";
import { Select } from "@material-ui/core";
import { Status } from "API";
import { SelectInputProps } from "@material-ui/core/Select/SelectInput";

export default function SelectStatus(props: SelectInputProps) {
  return (
    <Select {...props}>
      {Object.keys(Status).map((item, i) => {
        return <option value={item}>{item}</option>;
      })}
    </Select>
  );
}
